import { render, staticRenderFns } from "./SuperGraph2.vue?vue&type=template&id=2bd797ff&scoped=true"
import script from "./SuperGraph2.vue?vue&type=script&lang=js"
export * from "./SuperGraph2.vue?vue&type=script&lang=js"
import style0 from "./SuperGraph2.vue?vue&type=style&index=0&id=2bd797ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd797ff",
  null
  
)

export default component.exports